export function findS1Building(buildings = []) {
  return buildings.find((building) => {
    const searchable = [building?.name, building?.code, building?.id]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    return /(^|\s)s\s*1(\s|$)/i.test(searchable) || searchable.includes("s1");
  });
}

export function getDefaultBuilding(buildings = []) {
  return findS1Building(buildings) || buildings[0] || null;
}
